import _extends from "@babel/runtime/helpers/extends";
import { MarketplaceAppPaymentModelValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import React from 'react';
import { FREE_APP_CTA_LABEL_SECONDARY } from "../../../../constants";
import { CTAKind, PurchaseIntent } from "../../AppListing.types";
import { FreeAppSubtext } from "../AppListingCTA.styles";
import { ArtifactDownloadButton, getArtifactOrLearnMoreCTAs, LicensePurchaseForm, TrialLicenseForm, UnsupportedPrimaryCTA } from "../AppListingCTACollection";

function getFreeAppCTAs(ctaProps) {
  return {
    PrimaryCTA(ctaOverrides) {
      return /*#__PURE__*/React.createElement(ArtifactDownloadButton, _extends({
        appId: ctaProps.appId,
        buildNumber: ctaProps.appVersion.buildNumber,
        artifactDownloadLink: ctaProps.artifactDownloadLink,
        autoFocus: ctaProps.autoFocus,
        onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.PRIMARY)
      }, ctaOverrides));
    },

    SecondaryCTA(ctaOverrides) {
      return /*#__PURE__*/React.createElement(FreeAppSubtext, ctaOverrides, FREE_APP_CTA_LABEL_SECONDARY);
    }

  };
}

function getPaidViaAtlassianAppCTAs(ctaProps) {
  return {
    PrimaryCTA(ctaOverrides) {
      return /*#__PURE__*/React.createElement(TrialLicenseForm, _extends({
        appKey: ctaProps.appKey,
        appId: ctaProps.appId,
        buildNumber: ctaProps.appVersion.buildNumber,
        trialLicenseActivationLink: ctaProps.trialLicenseActivationLink,
        artifactDownloadLink: ctaProps.artifactDownloadLink,
        onClick: e => ctaProps.onClick(e, PurchaseIntent.TRY, CTAKind.PRIMARY),
        autoFocus: ctaProps.autoFocus,
        hosting: ctaProps.hosting
      }, ctaOverrides));
    },

    SecondaryCTA(ctaOverrides) {
      return /*#__PURE__*/React.createElement(LicensePurchaseForm, _extends({
        appKey: ctaProps.appKey,
        appId: ctaProps.appId,
        buildNumber: ctaProps.appVersion.buildNumber,
        licensePurchaseLink: ctaProps.licensePurchaseLink,
        artifactDownloadLink: ctaProps.artifactDownloadLink,
        autoFocus: ctaProps.autoFocus,
        onClick: e => ctaProps.onClick(e, PurchaseIntent.BUY, CTAKind.SECONDARY),
        hosting: ctaProps.hosting
      }, ctaOverrides));
    }

  };
}

export function getServerDCCTAs({
  appId,
  appKey,
  onClick,
  appVersion,
  artifactDownloadLink,
  trialLicenseActivationLink,
  licensePurchaseLink,
  hosting,
  autoFocus
}) {
  switch (appVersion.paymentModel) {
    case MarketplaceAppPaymentModelValues.Free:
      return getFreeAppCTAs({
        appId,
        onClick,
        appVersion,
        artifactDownloadLink,
        autoFocus
      });

    case MarketplaceAppPaymentModelValues.PaidViaAtlassian:
      return getPaidViaAtlassianAppCTAs({
        appKey,
        appId,
        onClick,
        appVersion,
        trialLicenseActivationLink,
        artifactDownloadLink,
        licensePurchaseLink,
        hosting,
        autoFocus
      });

    case MarketplaceAppPaymentModelValues.PaidViaPartner:
      return getArtifactOrLearnMoreCTAs({
        binaryAvailable: true,
        appId,
        onClick,
        appVersion,
        artifactDownloadLink,
        autoFocus
      });

    default:
      return {
        PrimaryCTA: UnsupportedPrimaryCTA
      };
  }
}